export default "__VITE_ASSET__D$wSDTUT__"